export default __webpack_public_path__ + "static/egnyte-agc-implementation-f00faa60268a746dfc2aee348b1d8440.jpg";